import React, { useEffect, useState , Fragment} from "react";
import withTranslator from "../Translator/withTranslation";
import withFosRouter from "../FosRouter/withFosRouting";
import { compose } from "recompose";
import styled from "@emotion/styled";
import colors from '../../../sass/brand_palette.scss';
import useFormWithRecaptcha from "./useFormWithRecaptcha"
import { keyframes } from "@emotion/react";

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);
  border-top: 2px solid #07ca;
  border-right: 2px solid #07ca;
  border-bottom: 2px solid #07cf;
  border-left: 2px solid #07c;
  background: transparent;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 0;
`;

const Input = styled.input`
   color: ${colors.blue1}!important;
`;

const Error= styled.p`
  color: white;
  background: rgba(255,0,0,0.9) !important;
  border-radius: 3px;
  text-align:center;
  font-size: 0.9rem;
  padding: 0.5rem;
`

const MailchimpSignupComponent = (props) => {
  const [signUpFinished, setSignupFinished] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isRecaptchaLoaded, setIsRecaptchaLoaded] = useState(false);
  const [submitting, setSubmitting] = useState(false);


  const onSubmit = (data) => {
    setSubmitting(true);
    fetch(props.r('mailchimp_newsletter_subscribe'), { 
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json"
      }
    }).then((response) => response.json())
      .then((json) => {
         if (json.status === true) {
          setSignupFinished(true);
          setSubmitting(false);
          if (typeof window._paq !== 'undefined') {
              window._paq.push(["setCustomData", {
                  "email" : data.email
              }]);
              window._paq.push(['trackPageView']);
          }
          window._sqzl = window._sqzl || [];
          window._sqzl.push({
            "event"      : "EmailOptIn",
            "email"      : data.email,
            "newsletter" : "yes",
            "marketing"  : "no",
            "service"    : "yes"
          });
        } else {
          setSignupFinished(false);
          setSubmitting(false);
        }
      });
  }

  const  {
    register,
    formState,
    recaptchaLoadedX,
    recaptchaComponent,
    executeRecaptcha,
  } = useFormWithRecaptcha({ onSubmit })
  
  useEffect(() => {
    if (typeof recaptchaLoadedX !== "undefined") { 
      setIsRecaptchaLoaded(recaptchaLoadedX);
      const lang = props.locale || "en";
      if(isLoaded) {
        const iframeGoogleCaptcha = document.getElementById('recaptcha-container').querySelector('iframe');

        if (iframeGoogleCaptcha) { 
          // 2. Retrieve the current language
          const currentLang = iframeGoogleCaptcha.getAttribute("src").match(/hl=(.*?)&/).pop();

          // 3. Verify if the language that you want to set is different to the current one
          if (currentLang !== lang) {
              // 4. If it is, change it
              iframeGoogleCaptcha.setAttribute(
                  "src",
                  iframeGoogleCaptcha.getAttribute("src").replace(
                      /hl=(.*?)&/,
                      'hl=' + lang + '&'
                  )
              );
          }
        }
      }
    }
  },[recaptchaLoadedX])

  useEffect( () => {
    setIsLoaded(true);
  },[]);

  if (!isLoaded) {
    return <div></div>
  }

  if (signUpFinished) {
    return (
      <div className="mt-4 pt-4 bor-solid bor-blue3 bor-thin bor-b-no bor-r-no bor-l-no">
        <div>{props.t("newsletter")}</div>
        <div className="bg-orange3 font-w600 mt-3 p-3  border-radius-default" style={{color:"#333"}}>{props.t('thank_you')}</div>
      </div>
    )
  } else {
    return (isLoaded && 
      <div className="mt-4 pt-4 bor-solid bor-blue3 bor-thin bor-b-no bor-r-no bor-l-no">
        <div>{props.t("newsletter")}</div>
        <form onSubmit={executeRecaptcha}>
            {submitting && (<div className="flex align-center justify-saround pt-4"> <Spinner /> </div>) }
            <div className={submitting ? "hidden" : ""}>
              <Input
                className="my-2 width-100"
                type="text"
                name="email"
                id="email"
                placeholder={props.t('emailaddress')}
                {...register("email", {
                  required: true,
                  pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                })}
              />
              {formState.errors.email && (
                  <Error className="">
                    {props.t("provide_valid_email")}
                  </Error>
                )}
              <input type="hidden" name="locale"  id="locale" value={props.locale} {...register("locale")} />  
              {recaptchaComponent}
              <button
                type="submit"
                disabled={!isRecaptchaLoaded }
                className={!isRecaptchaLoaded   ? "btn btn-primary width-100 disabled" : "btn btn-primary width-100 "}
              >
                {props.t("send")}
              </button>
              </div>
              <div className="mt-2 line-height-150">
                { props.t('signup_to_keep_updated')}
              </div>
        </form>
        </div>
      )
  }
}

export const MailchimpSignup = compose(
  withTranslator,
  withFosRouter
)(MailchimpSignupComponent);